export const attachmentStatus = Object.freeze({
  PENDING: 'pending',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
});
